export default {
  authorizations: [],
  page: {},
  links: {},
  authorizationLoading: false,
  authorizationCommentLoading: false,
  authorizationForms: [],
  authorizationFormsAndSteps: null,
  currentForm: null,
  currentStep: null,
  reimbursementStatus: null,
  authorizationCreated: null,
  error: {},
  files: [],
  beneficiary: {},
  sponsorSlug: sessionStorage.getItem('sponsorSlug') || null,
  sponsorSlugError: {},
  stepError: true,
  inputs: [],
  claimType: null,
  listAuthorization: JSON.parse(sessionStorage.getItem('listAuthorization')) || {},
  authorization: JSON.parse(sessionStorage.getItem('authorization')) || {},
  authorizationError: null,
  isReimbursement: null
}